import React, { Component } from 'react'
import { connect } from 'react-redux'

import Login from './login'
import Recover from './recover-password'
import Reset from './password-reset-token'
import RegisterRoute from './register-route'
import SwitchCSSTransitionGroup from 'switch-css-transition-group'
import { Route, withRouter, Redirect} from 'react-router'

import Scroll from 'react-scroll'
import queryString from 'query-string'

import { getCurrentUser } from 'state/selectors/userSelectors'

import { 
	updateKeyboardHeight,
	getReferrer,
} from 'state/actions'

import { 
	isMobile,
	scaleFactor,
	doDeepLink,
} from 'utils'

class Auth extends Component {
	constructor(props) {
		super(props)

		document.body.classList.add('light')

		this.state = {
			isVisible: false,
			affiliate: null
		}

		this.forcedEmail = null
		this.scroll = Scroll.animateScroll

		switch (this.props.location.pathname) {
			case '/auth/login':
				this.title = 'Welcome back.'
				break
			case '/auth/register':
				this.title = 'Register.'
				break
			case '/auth/recover':
				this.title = 'Recover password.'
				break
			case '/auth/password/reset':
				this.title = 'Recover password.'
				break
			default:
				break
		}

		const viewportWidth = document.documentElement.clientWidth

		if(viewportWidth <= 500){
			const scaleFactor = 500/viewportWidth

			const screenHeight = window.innerHeight < window.screen.height ? window.innerHeight : window.screen.height
			const newHeight = (screenHeight * scaleFactor) - 10

			// this'll give the wrong value in desktop device emulator, cause the 'window' is still bigger than the phone screen.
			document.body.style.minHeight = newHeight+'px'
		}

		if(window.location.search){
			window.initialQueryValues = window.location.search.replace('?','')
		}
	}

	componentWillMount = _ => {
		const {
			location,
			getReferrer,
			history,
			userData,
		} = this.props

		const thisQueryString = location.search
		const queries = queryString.parse(thisQueryString)

		if(queries.email){
			this.forcedEmail = queries.email
		}

		if(queries.referrer){
			const referrerId = queries.referrer

			getReferrer(referrerId, 'affiliate', referringAccount => {
				if(referringAccount){
					this.setState({
						affiliate: referringAccount
					})
				}
			})
		}

		doDeepLink(this.props)
	}

	componentWillUnmount = _ => {
		window.removeEventListener('keyboardWillShow', this.updateKeyboardHeight)
		window.removeEventListener('keyboardHeightWillChange', this.updateKeyboardHeight)
		window.removeEventListener('keyboardWillHide', this.updateKeyboardHeight)
	}

	componentDidMount(){
		setTimeout(_ => {
			this.setState({
				isVisible: true
			})
		},100)

		const {
			userData,
			history
		} = this.props

		if (userData && userData.lastOpenAccountSlug) {
			return history.push('/' + userData.lastOpenAccountSlug)
		}

		// this is identical to app.jsx
		if(isMobile()){
			window.addEventListener('keyboardWillShow', this.updateKeyboardHeight)
			window.addEventListener('keyboardWillHide', this.updateKeyboardHeight)
			window.addEventListener('keyboardHeightWillChange', this.updateKeyboardHeight)
		}
	}

	componentWillUpdate = nextProps => {
		const currentPathName = this.props.location.pathname
		const nextPathName = nextProps.location.pathname

		if(currentPathName != nextPathName){
			this.scrollToTop()
		}
	}

	scrollToTop = _ => {
		this.scroll.scrollToTop({
			duration: 300,
			delay: 0
		})
	}

	updateKeyboardHeight = e => {
		const newHeight = e.keyboardHeight ? (e.keyboardHeight * scaleFactor()) : 0

		this.props.updateKeyboardHeight(newHeight)
	}

	render() {
		const {
			location,
			match,
			keyboardHeight,
			userData
		} = this.props

		const {
			affiliate,
			isVisible
		} = this.state

		const routes = [
			{
				component: Login,
				path: '/login',
				key: 'login'
			},{
				component: RegisterRoute,
				path: '/register',
				key: 'register'
			},{
				component: Recover,
				path: '/recover',
				key: 'recover'
			},{
				component: Reset,
				path: '/password/reset',
				key: 'reset'
			}
		]

		let className = 'auth-container'

		if(isVisible){
			className += ' visible'
		}

		return (
			<div className={className} id="auth-container">
				<SwitchCSSTransitionGroup 
					location={location} 
					transitionName="pop" 
					transitionEnterTimeout={300} 
					transitionLeaveTimeout={300}
				>
					{routes.map((route, index) => {
						let Component = route.component

						return (
							<Route key={index} path={match.path+route.path} render={props => {
								return (
									<div 
										className={"auth-transition-container "+route.key}
										style={{
											paddingBottom: keyboardHeight+'px'
										}}
									>
										<Component 
											{...props} 
											visibilityCallback={this.setVisibility} 
											forcedEmail={this.forcedEmail}
											affiliate={affiliate}
											scrollToTop={this.scrollToTop}
											userData={userData}
										/>
										<div className="logo">
											<a href="https://hassl.co">
												<img src={document.base+'/images/logo.png'} alt="Hassl logo" />
											</a>
										</div>
									</div>
								);
							}} />

						)
					})}
					<Redirect from="/auth" to="/auth/login" />
				</SwitchCSSTransitionGroup>
			</div>
			)
	}
}

const mapStateToProps = state => {
	return {
		keyboardHeight: state.account.keyboardHeight,	
		userData: getCurrentUser(state),
		token: state.auth.token,
	}
}

export default withRouter(connect(mapStateToProps, {
	updateKeyboardHeight,
	getReferrer,
})(Auth))


// WEBPACK FOOTER //
// ./src/components/auth/auth.jsx